module.exports = __webpack_public_path__ + "images/logoSt-e7660ce4207a22b0359d09b16be6c230.png";